import { gql } from '@apollo/client';

export const siteGql = gql`
  query site($siteId: String!) {
    site(siteId: $siteId) {
      name
      terminalId
      client {
        timezone
      }
      monitoring {
        _id
        status
        currentAlarms {
          alarm
          effect
          extra
          startDate
        }
        lastPing
        notRespondingDelay
      }
    }
  }
`;
